import React from "react";
import { connect } from "react-redux";
import { guardarContactoEmergencia } from "./datos.act";
//import {OverlayTrigger, Tooltip} from 'react-bootstrap';

const mapState = (state) => {
  return {
    nombre: state.miPerfil.nombreCE,
    primerApellido: state.miPerfil.primerApellidoCE,
    correo: state.miPerfil.correoCE,
    familiarResponsable: state.miPerfil.familiarResponsableCE,
    parentesco: state.parentesco.dataParentescos,
    otroEspecifique: state.miPerfil.otroEspecifiqueCE,
    lada: state.miPerfil.ladaCE,
    telefono: state.miPerfil.telefonoCE,
    mensaje:
      state.miPerfil.mensajeCE === ""
        ? "Hola, tuve un percance. Me encuentro bien, no te preocupes."
        : state.miPerfil.mensajeCE,
    editing: state.miPerfil.editingCE,
  };
};

const mapDispatch = (dispatch) => {
  return {
    setDatos: (obj) => {
      dispatch({
        type: "MI_PERFIL_SET_CONTACTO_EMERGENCIA",
        nombre: obj.nombre,
        primerApellido: obj.primerApellido,
        correo: obj.correo,
        familiarResponsable: obj.familiarResponsable,
        otroEspecifique: obj.otroEspecifique,
        lada: obj.lada,
        telefono: obj.telefono,
        mensaje: obj.mensaje,
      });
    },
    setTemporal: (obj) => {
      dispatch({ type: "MI_PERFIL_SET_OBJ_TEMPORAL", obj: obj });
    },
    changeEditing: (flag) => {
      dispatch({ type: "MI_PERFIL_CHANGE_EDITING_CE", flag: flag });
    },
    setDatosCE: (obj) => {
      dispatch({
        type: "MI_PERFIL_SET_CONTACTO_EMERGENCIA",
        primerApellido: obj.primerApellido,
        nombre: obj.nombre,
        correo: obj.correo,
        familiarResponsable: obj.familiarResponsable,
        otroEspecifique: obj.otroEspecifique,
        lada: obj.lada,
        telefono: obj.telefono,
        mensaje: obj.mensaje,
      });
    },
    setDatosCEFlag: (flag) => {
      dispatch({ type: "MI_PERFIL_SET_CONTACTO_EMERGENCIA_FLAG", flag: flag });
    },
    guardarContactoEmergencia: (datos) => {
      dispatch(guardarContactoEmergencia(datos));
    },
    addEvento: (evento) => {
      dispatch({ type: "MI_PERFIL_SET_EVENT", evento: evento });
    },
  };
};
/*
const tooltip = (
  <Tooltip id="tooltip" bsClass="tooltip">Texto en el tooltip</Tooltip>
);*/

class ContactoDeEmergencia extends React.Component {
  state = {
    inputNombreActive: "input-active",
    inputPrimerApellidoActive: "input-active",
    inputCorreoActive: "input-active",
    inputFamiliarResponsableActive: "input-active",
    inputOtroEspecifiqueActive: "input-active",
    inputLadaActive: "input-active",
    inputTelefonoActive: "input-active",
    inputMensajeActive: "textarea-text",
    errorNombre: false,
    errorNombreMsj: "",
    errorPrimerApellido: false,
    errorPrimerApellidoMsj: "",
    msgErrorNombreApellido: "Este campo no debe ser mayor a 40 caracteres.",
    errorCorreo: false,
    errorCorreoMsj: false,
    errorFamiliarResponsable: false,
    errorFamiliarResponsableMsj: "",
    errorOtroEspecifique: false,
    errorOtroEspecifiqueMsj: "",
    errorLada: false,
    errorLadaMsj: "",
    errorTelefono: false,
    errorTelefonoMsj: "",
    msgErrorTelefono:
      "Tu número de teléfono con lada incluida debe ser de 10 dígitos.",
    errorSMS: false,
    errorSMSMsj: "",
    checkFlag: false,
    familiarResponsable: "",
    showOtroEspecifique: false,
  };

  componentDidUpdate(prevState) {
    const show = this.props.familiarResponsable === "9" ? true : false;
    if (this.props.familiarResponsable !== prevState.familiarResponsable) {
      this.setState({
        familiarResponsable: this.props.familiarResponsable,
        showOtroEspecifique: show,
      });
    }
  }

  componentWillUnmount() {
    this.props.changeEditing(false);
  }

  edit = () => {
    this.setState({ errorNombre: false });
    this.setState({ errorPrimerApellido: false });
    this.setState({ errorCorreo: false });
    this.setState({ errorFamiliarResponsable: false });
    this.setState({ errorOtroEspecifique: false });
    this.setState({ errorLada: false });
    this.setState({ errorTelefono: false });
    this.setState({ errorSMS: false });

    this.setState({
      inputNombreActive: this.props.nombre ? "input-active" : "",
    });
    this.setState({
      inputPrimerApellidoActive: this.props.primerApellido
        ? "input-active"
        : "",
    });
    this.setState({
      inputCorreoActive: this.props.correo ? "input-active" : "",
    });
    this.setState({
      inputFamiliarResponsableActive: this.props.familiarResponsable
        ? "input-active"
        : "",
    });
    this.setState({
      inputOtroEspecifiqueActive: this.props.otroEspecifique
        ? "input-active"
        : "",
    });
    this.setState({ inputLadaActive: this.props.lada ? "input-active" : "" });
    this.setState({
      inputTelefonoActive: this.props.telefono ? "input-active" : "",
    });

    if (this.props.editing) {
      this.props.addEvento("Cancelar-ContactoEmergencia");
    }

    this.props.changeEditing(!this.props.editing);
  };
  handleFocus = (event) => {
    let id = event.target.id;
    switch (id) {
      case "nombre":
        this.setState({ inputNombreActive: "input-active" });
        /*this.setState({errorNombre: false});
                this.setState({errorNombreMsj: ""});*/
        break;
      case "primerApellido":
        this.setState({ inputPrimerApellidoActive: "input-active" });
        break;
      case "correo":
        this.setState({ inputCorreoActive: "input-active" });
        break;
      case "familiarResponsable":
        this.setState({ inputFamiliarResponsableActive: "input-active" });
        break;
      case "otroEspecifique":
        this.setState({ inputOtroEspecifiqueActive: "input-active" });
        break;
      case "lada":
        this.setState({ inputLadaActive: "input-active" });
        break;
      case "telefono":
        this.setState({ inputTelefonoActive: "input-active" });
        break;
      case "mensaje":
        break;
    }
  };
  handleBlur = (event) => {
    let id = event.target.id;
    let value = event.target.value;
    switch (id) {
      case "nombre":
        this.setState({ inputNombreActive: value ? "input-active" : "" });
      case "primerApellido":
        this.setState({
          inputPrimerApellidoActive: value ? "input-active" : "",
        });
        break;
      case "correo":
        this.setState({
          inputCorreoActive: value ? "input-active" : "",
        });
        break;
      case "familiarResponsable":
        this.setState({
          inputfamiliarResponsableActive: value ? "input-active" : "",
        });
        break;
      case "otroEspecifique":
        this.setState({
          inputOtroEspecifiqueActive: value ? "input-active" : "",
        });
        break;
      case "lada":
        this.setState({ inputLadaActive: value ? "input-active" : "" });
        break;
      case "telefono":
        this.setState({ inputTelefonoActive: value ? "input-active" : "" });
        break;
    }
  };
  _handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.save();
    }
  };
  handleChange = (event) => {
    let id = event.target.id;
    let value = event.target.value;
    let tamano;
    let ultimo;
    let completo;
    let primero;
    switch (id) {
      case "lada":
        tamano = event.target.value.length;
        ultimo = value[value.length - 1];
        value = event.target.value;
        primero = value[0];
        if (primero != "+") {
          value = "+" + value;
          event.target.value = value;
          tamano = event.target.value.length;
          ultimo = value[value.length - 1];
        }
        if (isNaN(ultimo) && tamano == 2) {
          event.target.value = "";
          tamano = event.target.value.length;
          value = event.target.value;
        }
        if (tamano == 1) {
          event.target.value = "";
          break;
        }
        if (value) {
          for (var i = 1; i < value.length; i++) {
            if (value[i] != "+" && (isNaN(value[i]) || value[i] == " ")) {
              event.target.value = value.replace(value[i], "");
              value = event.target.value;
              i = -1;
            }
          }
        }
        break;
      case "telefono":
        ultimo = value[value.length - 1];
        if (value) {
          for (var i = 0; i < value.length; i++) {
            if (isNaN(value[i]) || value[i] == " ") {
              event.target.value = value.replace(value[i], "");
              value = event.target.value;
              i = -1;
            }
          }
        }
        break;
    }
    if (this.state.checkFlag) {
      switch (id) {
        case "nombre":
          this.setState({ errorNombre: false });
          this.setState({ errorNombreMsj: "" });
          break;
        case "primerApellido":
          this.setState({ errorPrimerApellido: false });
          this.setState({ errorPrimerApellidoMsj: "" });
          break;
        case "correo":
          this.setState({ errorCorreo: false });
          this.setState({ errorCorreoMsj: "" });
          break;
        case "otroEspecifique":
          this.setState({ errorOtroEspecifique: false });
          this.setState({ errorOtroEspecifiqueMsj: "" });
          break;
        case "lada":
          completo = value.substring(1, value.length) + this.refs.tel.value;
          if (value && completo.length != 10) {
            this.setState({ errorTelefono: true });
            this.setState({
              errorTelefonoMsj: this.state.msgErrorTelefono,
            });
          } else {
            this.setState({ errorTelefono: false });
            this.setState({ errorTelefonoMsj: "" });
          }
          break;
        case "telefono":
          completo =
            this.refs.ld.value.substring(1, this.refs.ld.value.length) + value;
          if (value && completo.length != 10) {
            this.setState({ errorTelefono: true });
            this.setState({
              errorTelefonoMsj: this.state.msgErrorTelefono,
            });
          } else {
            this.setState({ errorTelefono: false });
            this.setState({ errorTelefonoMsj: "" });
          }
          break;
        case "mensaje":
          this.setState({ errorSMS: false });
          this.setState({ errorSMSMsj: "" });
          break;
      }
    }
  };
  save = () => {
    this.setState({ checkFlag: true });

    const otroEspecifiqueValue = this.state.showOtroEspecifique
      ? this.refs.oes.value
      : " ";

    let obj = {
      flag: "ce",
      nombre: this.refs.nmbr.value,
      primerApellido: this.refs.pa.value,
      familiarResponsable: this.refs.fr.value,
      otroEspecifique: otroEspecifiqueValue,
      correo: this.refs.co.value,
      lada: this.refs.ld.value,
      telefono: this.refs.tel.value,
      mensaje: this.refs.msj.value,
    };

    let ok = true;

    /*
        if(!obj.nombre && !obj.lada && !obj.telefono && !obj.mensaje) {
            this.props.setDatosCEFlag(false);
            this.props.setDatosCE(obj);
            this.props.changeEditing(false);
            return;
        }*/
    for (var key in obj) {
      if (!obj[key]) {
        switch (key) {
          case "nombre":
            ok = false;
            this.setState({ errorNombre: true });
            this.setState({ errorNombreMsj: "Campo requerido." });
            this.props.addEvento("CampoRequerido-ContactoEmergencia");
            break;
          case "primerApellido":
            ok = false;
            this.setState({ errorPrimerApellido: true });
            this.setState({ errorPrimerApellidoMsj: "Campo requerido." });
            this.props.addEvento("CampoRequerido-ContactoEmergencia");
            break;
          case "correo":
            ok = false;
            this.setState({ errorCorreo: true });
            this.setState({ errorCorreoMsj: "Campo requerido." });
            this.props.addEvento("CampoRequerido-ContactoEmergencia");
            break;
          case "familiarResponsable":
            ok = false;
            this.setState({ errorParentesco: true });
            this.setState({ errorParentescoMsj: "Campo requerido." });
            this.props.addEvento("CampoRequerido-ContactoEmergencia");
            break;
          case "otroEspecifique":
            ok = false;
            this.setState({ errorOtroEspecifique: true });
            this.setState({ errorOtroEspecifiqueMsj: "Campo requerido." });
            this.props.addEvento("CampoRequerido-ContactoEmergencia");
            break;
          case "lada":
            ok = false;
            this.setState({ errorTelefono: true });
            this.setState({ errorTelefonoMsj: "Campo Lada requerido." });
            this.props.addEvento("CampoRequerido-ContactoEmergencia");
            break;
          case "telefono":
            ok = false;
            this.setState({ errorTelefono: true });
            this.setState({ errorTelefonoMsj: "Campo requerido." });
            this.props.addEvento("CampoRequerido-ContactoEmergencia");
            break;
          case "mensaje":
            ok = false;
            this.setState({ errorSMS: true });
            this.setState({ errorSMSMsj: "Campo requerido." });
            this.props.addEvento("CampoRequerido-ContactoEmergencia");
            break;
        }
      }
    }
    const nombre = obj.nombre;
    const primerApellido = obj.primerApellido;
    const familiarResponsable = obj.familiarResponsable;
    const otroEspecifique = obj.otroEspecifique;
    const correo = obj.correo;
    const telefono = obj.telefono;
    const completo = obj.lada.substring(1, obj.lada.length) + telefono;

    // Validación longitud campo nombre
    if (nombre.length > 40) {
      ok = false;
      this.setState({ errorNombre: true });
      this.setState({
        errorNombreMsj: this.state.msgErrorNombreApellido,
      });
      this.props.addEvento("ErrorNombre-ContactoEmergencia");
    } else {
      this.setState({ errorNombre: false });
      this.setState({ errorNombreMsj: "" });
    }

    // Validación longitud campo primerApelido
    if (primerApellido.length > 40) {
      ok = false;
      this.setState({ errorPrimerApellido: true });
      this.setState({
        errorPrimerApellidoMsj: this.state.msgErrorNombreApellido,
      });
      this.props.addEvento("ErrorPerrorPrimerApellido-ContactoEmergencia");
    } else {
      this.setState({ errorPrimerApellido: false });
      this.setState({ errorPrimerApellidoMsj: "" });
    }

    // Validacion para campo famiiar responsable
    if (familiarResponsable === 0) {
      ok = false;
      this.setState({ errorFamiliarResponsable: true });
      this.setState({ errorFamiliarResponsableMsj: "Este campo es requerido" });
      this.props.addEvento("ErrorFamiliarResponsable-ContactoEmergencia");
    } else {
      this.setState({ errorFamiliarResponsable: false });
      this.setState({ errorFamiliarResponsableMsj: "" });
    }

    // Validación longitud campo otroEspecifique
    if (otroEspecifique.length > 40) {
      ok = false;
      this.setState({ errorOtroEspecifique: true });
      this.setState({
        errorOtroEspecifiqueMsj: this.state.msgErrorNombreApellido,
      });
      this.props.addEvento("ErrorOtroEspecifique-ContactoEmergencia");
    } else {
      this.setState({ errorOtroEspecifique: false });
      this.setState({ errorOtroEspecifiqueMsj: "" });
    }

    // Validacion longitud del telefono
    if (completo.length != 10) {
      ok = false;
      this.setState({ errorTelefono: true });
      this.setState({
        errorTelefonoMsj: this.state.msgErrorTelefono,
      });
      this.props.addEvento("ErrorTelefono-ContactoEmergencia");
    } else {
      this.setState({ errorTelefono: false });
      this.setState({ errorTelefonoMsj: "" });
    }

    // Validacion de telefono numeros repetidos consecutivos
    const patronTelefono = /(.)\1{4,}/;
    if (patronTelefono.test(telefono)) {
      ok = false;
      this.setState({ errorTelefono: true });
      this.setState({
        errorTelefonoMsj:
          "Debe ingresar un número telefónico que no contenga más de 5 números de forma consecutiva",
      });
      this.props.addEvento("ErrorTelefono-ContactoEmergencia");
    } else {
      this.setState({ errorTelefono: false });
      this.setState({ errorTelefonoMsj: "" });
    }

    // Validacion correo electronico
    const patronCorreo =
      /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    if (!patronCorreo.test(correo)) {
      ok = false;
      this.setState({ errorCorreo: true });
      this.setState({
        errorCorreoMsj: "Debe ingresar un correo electrónico valido.",
      });
      this.props.addEvento("ErrorCorreo-ContactoEmergencia");
    } else {
      this.setState({ errorCorreo: false });
      this.setState({ errorCorreoMsj: "" });
    }

    if (ok) {
      this.props.setDatosCEFlag(true);
      this.props.guardarContactoEmergencia(obj);
      this.props.changeEditing(false);
      this.props.addEvento("DatosCorrectos-ContactoEmergencia");
    }
  };

  frChange = (event) => {
    const frValue = event.target.value;
    const show = frValue === "9" ? true : false;

    this.setState({
      familiarResponsable: frValue,
      showOtroEspecifique: show,
    });
  };

  render() {
    return (
      <div className="col-xs-12">
        <div className="card perfil-card">
          <div className="card-header">
            <div className="row">
              <div className="col-xs-6">
                <i>
                  <img src={require("../img/contacto-icono.svg")} />
                </i>
                {/*<OverlayTrigger placement="top" overlay={tooltip}>
                                </OverlayTrigger>*/}
                <b>Contacto de emergencia</b>
                <span className="orange-tooltip">
                  <button
                    type="button"
                    className="btn btn-primary btn-lg"
                    data-toggle="modal"
                    data-target="#modal-cemergencia"
                  >
                    ?
                  </button>
                </span>
              </div>
              <div className="col-xs-6">
                <div className="text-right card-actions-btn">
                  {!this.props.editing && (
                    <a id="ce_edit" onClick={this.edit} className="orange-btn">
                      Editar <img src={require("../img/editar-icono.png")} />
                    </a>
                  )}
                  {this.props.editing && (
                    <div>
                      <a
                        id="ce_cancel"
                        onClick={this.edit}
                        className="pad-right-10"
                      >
                        Cancelar
                      </a>
                      <a
                        id="ce_acept"
                        onClick={this.save}
                        className="orange-btn"
                      >
                        Guardar
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              {!this.props.editing && (
                <div className="input-wrap">
                  <label>Nombre</label>
                  <span className="blue-text">
                    <p>
                      <b className="ww">
                        {this.props.nombre.length > 44
                          ? this.props.nombre.substring(0, 44) + "..."
                          : this.props.nombre}
                      </b>
                    </p>
                  </span>
                </div>
              )}
              {this.props.editing && (
                <div className="input-wrap">
                  <label>Nombre</label>
                  <span className={this.state.inputNombreActive}>
                    <input
                      ref="nmbr"
                      defaultValue={this.props.nombre}
                      id="nombre"
                      type="text"
                      onBlur={this.handleBlur}
                      onFocus={this.handleFocus}
                      onKeyPress={this._handleKeyPress}
                      onChange={this.handleChange}
                    />
                  </span>
                  {this.state.errorNombre && (
                    <div className="error-wrap">
                      <div className="msj-error">
                        <p>{this.state.errorNombreMsj}</p>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="col-xs-12">
              {!this.props.editing && (
                <div className="input-wrap">
                  <label>Primer apellido</label>
                  <span className="blue-text">
                    <p>
                      <b className="ww">
                        {this.props.primerApellido.length > 44
                          ? this.props.primerApellido.substring(0, 44) + "..."
                          : this.props.primerApellido}
                      </b>
                    </p>
                  </span>
                </div>
              )}
              {this.props.editing && (
                <div className="input-wrap">
                  <label>Primer apellido</label>
                  <span className={this.state.inputNombreActive}>
                    <input
                      ref="pa"
                      defaultValue={this.props.primerApellido}
                      id="primerApellido"
                      type="text"
                      onBlur={this.handleBlur}
                      onFocus={this.handleFocus}
                      onKeyPress={this._handleKeyPress}
                      onChange={this.handleChange}
                    />
                  </span>
                  {this.state.errorPrimerApellido && (
                    <div className="error-wrap">
                      <div className="msj-error">
                        <p>{this.state.errorPrimerApellidoMsj}</p>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="col-xs-12">
              {!this.props.editing && (
                <div className="input-wrap">
                  <label>Correo electrónico</label>
                  <span className="blue-text">
                    <p>
                      <b className="ww">
                        {this.props.correo.length > 44
                          ? this.props.correo.substring(0, 44) + "..."
                          : this.props.correo}
                      </b>
                    </p>
                  </span>
                </div>
              )}
              {this.props.editing && (
                <div className="input-wrap">
                  <label>Correo electrónico</label>
                  <span className={this.state.inputCorreoActive}>
                    <input
                      ref="co"
                      defaultValue={this.props.correo}
                      id="correo"
                      type="text"
                      onBlur={this.handleBlur}
                      onFocus={this.handleFocus}
                      onKeyPress={this._handleKeyPress}
                      onChange={this.handleChange}
                    />
                  </span>
                  {this.state.errorCorreo && (
                    <div className="error-wrap">
                      <div className="msj-error">
                        <p>{this.state.errorCorreoMsj}</p>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="col-xs-12">
              <div className="input-wrap">
                <label>Familiar responsable</label>

                <span className="clearfix input-active">
                  <select
                    ref="fr"
                    name="familiarResponsable"
                    className="col-xs-1"
                    value={this.state.familiarResponsable}
                    onChange={this.frChange}
                    disabled={!this.props.editing}
                  >
                    <option value="0">Selecciona una opcion</option>
                    {this.props.parentesco.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                  </select>
                </span>
                {this.state.errorFamiliarResponsable && (
                  <div className="error-wrap">
                    <div className="msj-error">
                      <p>{this.state.errorFamiliarResponsableMsj}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-xs-12">
              {!this.props.editing && this.state.showOtroEspecifique && (
                <div className="input-wrap">
                  <label>Otro especifique</label>
                  <span className="blue-text">
                    <p>
                      <b className="ww">
                        {this.props.otroEspecifique.length > 40
                          ? this.props.otroEspecifique.substring(0, 40) + "..."
                          : this.props.otroEspecifique}
                      </b>
                    </p>
                  </span>
                </div>
              )}
              {this.props.editing && this.state.showOtroEspecifique && (
                <div className="input-wrap">
                  <label>Otro especifique</label>
                  <span className={this.state.inputOtroEspecifiqueActive}>
                    <input
                      ref="oes"
                      defaultValue={
                        this.props.otroEspecifique
                          ? this.props.otroEspecifique.trim()
                          : ""
                      }
                      id="otroEspecifique"
                      type="text"
                      onBlur={this.handleBlur}
                      onFocus={this.handleFocus}
                      onKeyPress={this._handleKeyPress}
                      onChange={this.handleChange}
                    />
                  </span>
                  {this.state.errorOtroEspecifique && (
                    <div className="error-wrap">
                      <div className="msj-error">
                        <p>{this.state.errorOtroEspecifiqueMsj}</p>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="col-xs-12 mt-10">
              <h6>
                <i>
                  <img src={require("../img/icon-cellphone.svg")} />
                </i>
                Teléfono celular
              </h6>
              <div className="row">
                <div className="col-md-2 col-xs-3">
                  {!this.props.editing && (
                    <div className="input-wrap">
                      <label>Lada</label>
                      <span className="blue-text">
                        <p>
                          <b>{this.props.lada}</b>
                        </p>
                      </span>
                    </div>
                  )}
                  {this.props.editing && (
                    <div className="input-wrap">
                      <label>Lada</label>
                      <span className={this.state.inputLadaActive}>
                        <input
                          ref="ld"
                          maxLength="4"
                          defaultValue={this.props.lada}
                          id="lada"
                          type="text"
                          onBlur={this.handleBlur}
                          onFocus={this.handleFocus}
                          onKeyPress={this._handleKeyPress}
                          onChange={this.handleChange}
                        />
                      </span>
                    </div>
                  )}
                </div>
                <div className="col-md-10 col-xs-9">
                  {!this.props.editing && (
                    <div className="input-wrap">
                      <label>Teléfono celular</label>
                      <span className="blue-text">
                        <p>
                          <b>{this.props.telefono}</b>
                        </p>
                      </span>
                    </div>
                  )}
                  {this.props.editing && (
                    <div className="input-wrap">
                      <label>Teléfono celular</label>
                      <span className={this.state.inputTelefonoActive}>
                        <input
                          maxLength="8"
                          ref="tel"
                          defaultValue={this.props.telefono}
                          id="telefono"
                          type="text"
                          onBlur={this.handleBlur}
                          onFocus={this.handleFocus}
                          onKeyPress={this._handleKeyPress}
                          onChange={this.handleChange}
                        />
                      </span>
                      {this.state.errorTelefono && (
                        <div className="error-wrap">
                          <div className="msj-error">
                            <p>{this.state.errorTelefonoMsj}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-xs-12 mt-25">
              {!this.props.editing && (
                <div className="input-wrap">
                  <label>Mensaje de emergencia</label>
                  <span className="textarea-text">
                    <p className="ww">
                      {this.props.mensaje.length > 150
                        ? this.props.mensaje.substring(0, 67) + "..."
                        : this.props.mensaje}
                    </p>
                  </span>
                </div>
              )}
              {this.props.editing && (
                <div className="input-wrap">
                  <label>Mensaje de emergencia</label>
                  <span className={this.state.inputMensajeActive}>
                    <textarea
                      ref="msj"
                      maxLength="150"
                      defaultValue={this.props.mensaje}
                      id="mensaje"
                      type="text"
                      onBlur={this.handleBlur}
                      onFocus={this.handleFocus}
                      onKeyPress={this._handleKeyPress}
                      onChange={this.handleChange}
                    ></textarea>
                  </span>
                  {this.state.errorSMS && (
                    <div className="error-wrap">
                      <div className="msj-error">
                        <p>{this.state.errorSMSMsj}</p>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="col-xs-12 mt-50 texto-12">
              <p className="blue-text">
                <span className="orange-text">*</span> Al reportar una
                emergencia enviaremos un mensaje con tu ubicación a tu contacto.
              </p>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="modal-cemergencia"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-cemergenciaLabel"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4
                  className="modal-title orange-text"
                  id="modal-cemergenciaLabel"
                >
                  Importante
                </h4>
              </div>
              <div className="modal-body">
                <p>
                  Al reportar un siniestro desde la aplicación Soy Cliente GNP,
                  el contacto de emergencia recibirá un mensaje con tu
                  ubicación.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn orange-btn"
                  data-dismiss="modal"
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapState, mapDispatch)(ContactoDeEmergencia);



// WEBPACK FOOTER //
// ./src/miPerfil/contactoDeEmergencia.cmpt.js